import { format } from 'date-fns';
import ja from 'date-fns/locale/ja';

export default function getWeekName(paramDate) {
  const date = new Date(paramDate);
  return format(date, 'eee', { locale: ja });
}
